














































































































































import NoticeModal from '@/components/NoticeModal.vue';
import { UserMixin, SlackMixin } from '@/Mixin';

export default {
  name: 'PremiumAd',
  components: { NoticeModal },
  mixins: [UserMixin, SlackMixin],
  methods: {
    async sendRequestPremium() {
      const url = new URL(window.location.href);
      const message = `${(this as any).loginUserName}様(${
        (this as any).loginEmail
      })からプレミアムプランの申請依頼がきました。`;
      await (this as any).sendSlackMessage(message, '_paid-services');
      //reset
      this.$modal.show('sentPremiumRequestModal');
    },
    async sendInquiryPremium() {
      const url = new URL(window.location.href);
      const message = `${(this as any).loginUserName}様(${
        (this as any).loginEmail
      })からプレミアムプランのお問い合わせがきました。`;
      await (this as any).sendSlackMessage(message, '_paid-services');
      //reset
      this.$modal.show('sentPremiumInquiryModal');
    },
  },
};
